export default {
  headerContent: {
    title: 'Sompo Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Sompo Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'Sompo Sigorta Ferdi Kaza Sigortası Nedir? ',
      content: [
        'Yaşam sürprizler ile dolu olsa da her zaman iyi sonuçlar doğurmaz.',
        'Yaşamın barındırdığı riskler durumlar her ne kadar istenmese de başa gelebilir ve bu durumlara karşı önceden güvence alınmadıysa oldukça güç bir halde atlatılabilir. Ferdi kaza sigortası ise bu durumların önüne geçmek için yerinde bir tercih olarak belirmektedir.',
        'Oluşabilecek her türlü kaza durumuna karşı güvence sunan Sompo Sigorta ferdi kaza sigortası beklenmedik ve ani kazalar sonucu sigortalı kişinin ya da yakınlarının maddi zorluklar çekmemesi için düzenlenmiş sigorta türüdür.'
      ]
    },
    subContent: {
      title: 'Sompo Sigorta Ferdi Kaza Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Kazalar gündelik yaşamı aksattığı ve pek çok risk durumu olduğu için Sompo Sigorta tarafından geniş içerilikli bir sigorta hazırlanmıştır. ',
          subList: null
        },
        {
          paragraph:
            'Bu sigorta kapsamında ev, iş, trafik kazaları kadar hayvanlardan kaynaklanacak kazalar da güvence altına alınmıştır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sompo Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
